import secondLogo from "../assets/images/secondLogo.png";
import evc from "../assets/images/evc.png";
import dev from "../assets/images/dev.png";
import crissier from "../assets/images/crissier.png";
import geneve from "../assets/images/geneve_logo.png";
import pully from "../assets/images/pully_logo.png";
import saint_prex_logo from "../assets/images/saint-prex-logo.jpeg";
import denges from "../assets/images/denges_logo.svg";
import vetcity from "../assets/images/vetcity.png";
import vevey from "../assets/images/digimidi_vevey.png";
import molage from "../assets/images/molage_logo.png";
import jordils from "../assets/images/logo_Jordils.png";
let hostname = window.location.hostname.split(".").slice(-2).join(".");
let host = window.location.hostname;
export const companyInfo = () => {
  if (
    host == "stprex.vetmidi.org" ||
    window.location.hostname == "stprex.vetmidi.org"
  ) {
    return {
      cname: "SAINT-PREX",
      CimagePath: saint_prex_logo,
      cdescription: "Urgences vétérinaires",
    };
  }
  else if (hostname == "denges.digimidi.ch" || window.location.hostname == "denges.digimidi.ch") {
    return {
      cname: "Denges",
      CimagePath: denges,
      cdescription: "Urgences vétérinaires",
    };
  }
  else if (hostname == "vetmidi.org" || window.location.hostname == "vetmidi.org") {
    return {
      cname: "VETMIDI",
      CimagePath: secondLogo,
      cdescription: "Urgences vétérinaires",
    };
  } else if (
    hostname == "evc.clinic" ||
    window.location.hostname == "evc.clinic"
  ) {
    return {
      cname: "EVC",
      CimagePath: evc,
      cdescription: "Urgences vétérinaires",
    };
  } else if (
    hostname == "crissier.digimidi.ch" ||
    window.location.hostname == "crissier.digimidi.ch"
  ) {
    return {
      cname: "CRISSIER",
      CimagePath: crissier,
      cdescription: "Urgences vétérinaires",
    };
  }
  else if (
    hostname == "geneve.digimidi.ch" ||
    window.location.hostname == "geneve.digimidi.ch"
  ) {
    return {
      cname: "GENEVE",
      CimagePath: geneve,
      cdescription: "Urgences vétérinaires",
    };
  }
  else if (
    hostname == "pully.digimidi.ch" ||
    window.location.hostname == "pully.digimidi.ch"
  ) {
    return {
      cname: "PULLY",
      CimagePath: pully,
      cdescription: "Urgences vétérinaires",
    };
  }
  else if (
    hostname == "vetcity.digimidi.ch" ||
    window.location.hostname == "vetcity.digimidi.ch"
  ) {
    return {
      cname: "VETCITY",
      CimagePath: vetcity,
      cdescription: "Urgences vétérinaires",
    };
  }
  else if (
    hostname == "vevey.digimidi.ch" ||
    window.location.hostname == "vevey.digimidi.ch"
  ) {
    return {
      cname: "VEVEY",
      CimagePath: vevey,
      cdescription: "Urgences vétérinaires",
    };
  }
  else if (
    hostname == "molage.digimidi.ch" ||
    window.location.hostname == "molage.digimidi.ch"
  ) {
    return {
      cname: "MOLAGE",
      CimagePath: molage,
      cdescription: "Urgences vétérinaires",
    };
  }
  else if (
    hostname == "jordils.digimidi.ch" ||
    window.location.hostname == "jordils.digimidi.ch"
  ) {
    return {
      cname: "JORDILS",
      CimagePath: jordils,
      cdescription: "Urgences vétérinaires",
    };
  }
 else {
    return {
      cname: "dev",
      CimagePath: dev,
      cdescription: "N/A",
    };
  }
};
